import {useEffect, useState} from 'react'
import {formatDate} from 'utils/intlDate'
import SearchContainer from 'layouts/components/Search/SearchContainer'
import RangePicker from 'components/ui/RangePicker'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import Table from 'components/ui/Table'
import {Link, useNavigate} from 'react-router-dom'
import * as Styles from 'layouts/PrivateLayout.styles'
import Button from 'components/ui/Button'
import {ICustomer, useGetCustomersQuery} from 'services/customers'
import Spinner from 'components/ui/Spinner'

const Customers = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [limit] = useState(10);

    // Set initial dates to today
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD

    const [startDate, setStartDate] = useState(formattedToday);
    const [endDate, setEndDate] = useState(formattedToday);

    const {
        data: customers,
        isLoading,
        isFetching,
        refetch
    } = useGetCustomersQuery({limit, page, startDate, endDate});

    useEffect(() => {
        refetch();
    }, [startDate, endDate, refetch]);


    const columns = [
        {
            field: 'created_at',
            headerName: 'Created At',
            render: (data: ICustomer) => formatDate(new Date(data?.created_at))
        },
        {
            field: 'name',
            headerName: 'Name',
            render: (data: ICustomer) => (
                <div className="flex items-center gap-3">{data?.name}</div>
            )
        },
        {
            field: 'email',
            headerName: 'Email',
            render: (data: ICustomer) => data?.email
        }
    ]

    const handleDetailClick = (id: number) => {
        navigate(`/admin/customers/${id}`)
    }

    return (
        <div>
            <SearchContainer/>
            <div className="mt-5">
                <Styles.PageTitleContainer>
                    Customers
                    <Styles.PageTitleContainerButtons>
                        <RangePicker
                            startDate={startDate}
                            endDate={endDate}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                        />
                        {/*<Link to={'create'} state={{currentCustomers: customers}}>*/}
                        {/*    <Button startIcon={<AddOutlinedIcon/>}>Add Customer</Button>*/}
                        {/*</Link>*/}
                        {/*<Button onClick={() => navigate('/admin/export')}>Export CSV</Button>*/}
                    </Styles.PageTitleContainerButtons>
                </Styles.PageTitleContainer>
            </div>
            {!isLoading && !isFetching ? (
                <Table
                    columns={columns}
                    rows={customers?.customers || []}
                    showPagination
                    page={page}
                    setPage={setPage}
                    onPrevPage={() => setPage(page - 1)}
                    onNextPage={() => setPage(page + 1)}
                    totalPages={Math.ceil(Number(customers?.records_count) / limit)}
                    isFetching={isFetching || isLoading}
                    usePointer
                    onRowClick={handleDetailClick}
                    emptyTitleText="No Customers yet"
                    emptyText="There are no customers available, try selecting a different date range!"
                />
            ) : (
                <Spinner/>
            )}
        </div>
    )
}

export default Customers
